<template>
<div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
        <v-layout row wrap justify-center>
            <v-flex xs12>
                <v-toolbar dark color="primary">
                    <v-layout row justify-end align-center>
                        <v-flex xs12 md2>
                            <v-select
                                label="Tòa nhà"
                                :disabled="loading.submit"
                                v-model="chosen_building"
                                :items="list_building"
                                prepend-icon="domain"
                                required
                                single-line
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md2>
                            <v-text-field
                            v-model="search"
                            prepend-icon="search"
                            label="Tìm kiếm"
                            single-line
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md2>
                            <v-select
                                label="Tìm theo"
                                :disabled="loading.submit"
                                v-model="search_type"
                                :items="list_search_type"
                                prepend-icon="visibility"
                                required
                                single-line
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md2>
                            <v-select
                                label="Trạng thái cọc"
                                :disabled="loading.submit"
                                v-model.number="chosen_deposit_status"
                                :items="list_deposit_status"
                                prepend-icon="domain"
                                required
                                single-line
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md2>
                            <v-btn @click="getData" color="green" dark>
                                Tìm kiếm
                            </v-btn>
                        </v-flex>

                        <v-flex xs12 md2>
                            
                            <v-btn :loading="export_csv.loading" @click="exportCSV" color="primary" dark>XUẤT EXCEL</v-btn>
                            <export-csv-button
                                :trigger="export_csv.trigger"
                                :title="export_csv.title"
                                :rows="export_csv.rows"
                            ></export-csv-button>
                        </v-flex>
                    </v-layout>
                </v-toolbar>
                <div class="mt-3">
                    <v-card>
                        
                        <v-data-table
                            :headers="headers"
                            :items="items"
                            :rows-per-page-items="rowPerPage"
                            disable-initial-sort
                            :loading="loader"
                        >
                            <template #items="props">
                                <td class="text-center">{{ props.item.room_id }}</td>
                                <td class=" text-no-wrap">{{ props.item.phone }}</td>
                                <td class=" text-no-wrap">{{ props.item.date_deposit | formatTimeServer }}</td>
                                <td class="text-center text-no-wrap">{{ props.item.date_schedule_in | formatTimeServer }}</td>
                                <td class=" text-no-wrap">{{ room_status[props.item.room_status] }}</td>
                                <td class=" text-no-wrap">
                                    <!-- <v-chip
                                        :color="props.item.deposit_status ? 'green' : 'yellow'"
                                        :text-color="props.item.deposit_status ? 'white' : 'black'"
                                    >
                                        {{ props.item.deposit_status ? 'Đã cọc đủ' : 'Chưa cọc đủ' }}
                                    </v-chip> -->
                                    <span :class="['v-badge', props.item.deposit_status ? 'primary' : 'warning']">
                                        {{ props.item.deposit_status ? 'Đã cọc đủ' : 'Chưa cọc đủ' }}
                                    </span>
                                </td>
                                <td class="">{{ props.item.room_price | formatNumber }}</td>
                                <td class="">{{ props.item.deposit_price | formatNumber }}</td>
                                <td class="">{{ props.item.total_price | formatNumber }}</td>
                                <td class="">{{ props.item.collected_amount | formatNumber}}</td>
                                <td class="">{{ props.item.debt | formatNumber}}</td>
                                <td class=" text-no-wrap">{{ props.item.room_state_id }}</td>
                            </template>
                        </v-data-table>
                    </v-card>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import api from '../../api'
import { buildParamQuery, formatTimeServer } from '../../helpers/helpers.js'
import moment from 'moment'
import { room_status } from '../../constants/db-config' 
import { list_building } from '../../constants/db-config'
import ExportCsvButton from '../../components/ExportExcel/ExportCsvButton'

export default {
    name: "bang-theo-doi-coc",
    components: {
        ExportCsvButton
    },
    data() {
        return {
            loader: false,
            search:'',
            headers: [
                { text: "Số phòng", align: "left", value: "room_id" },
                { text: "SDT", align: "center", value: "phone", sortable: false },
                { text: "Ngày đặt cọc", align: "left", value: "date_deposit" },
                { text: "Ngày hẹn nhận phòng", align: "left", value: "date_schedule_in" },
                { text: "Tình trạng phòng", align: "left", value: "room_status" },
                { text: "Tình trạng cọc", align: "left", value: "deposit_status" },
                { text: "Giá phòng", align: "left", value: "room_price" },
                { text: "Giá cọc", align: "left", value: "deposit_price" },
                { text: "Tổng cộng", align: "left", value: "total_price" },
                { text: "Tiền đã đóng", align: "left", value: "collected_amount" },
                { text: "Tiền còn thiếu", align: "left", value: "debt" },
                { text: "Mã quản lý", align: "left", value: "room_state_id" },
            ],
            list_building: [
                ...list_building,
                {text: 'Tất cả', value: ''},
            ],
            list_search_type: [
                { text: 'Số phòng', value: 'roomId' },
                { text: 'Mã quản lý', value: 'roomStateId' },
            ],
            list_deposit_status: [
                { text: 'Tất cả', value: '' },
                { text: 'Chưa cọc đủ', value: 0 },
                { text: 'Đã cọc đủ', value: 1 },
            ],
            chosen_deposit_status: 0,
            chosen_building: '',
            items: [],
            loading: {
                submit: false
            },
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
            search_type: 'roomId',
            menu_date_start: false,
            menu_date_end: false,
            date_start: moment().startOf('month').format('YYYY-MM-DD'),
            date_end: new Date().toISOString().substr(0, 10),
            room_status,
			export_csv: {
				loading: false,
				trigger: false,
				title: "",
				rows: []
			}
        };
    },
    mounted() {
    },
    created(){
        this.getData()
    },
    methods: {
        getData: async function (){
            this.items = []
            this.loader = true
            const params = {
                building: this.chosen_building,
                [this.search_type]: this.search,
                depositStatus: this.chosen_deposit_status
            }
            const query = buildParamQuery(params)
            let data = await api.getDepositStatus(query)
            this.items = data.data.data.map( item => this.handleData(item) )
            this.loader = false
        },
        handleData: function (data){
            const room_info = data.contractInfo && data.contractInfo[0] ? data.contractInfo[0] : data.roomInfo[0]
            data.room_price = room_info.room_price
            data.deposit_price = room_info.deposit_price
            data.total_price = data.deposit_price + data.room_price
            data.collected_amount = data.deposits.reduce( (accu, deposit) => accu += Number(deposit.deposit_amount), 0)
            data.debt = data.total_price - data.collected_amount
            data.date_deposit = data.deposits && data.deposits[0] ? data.deposits[0].date_deposit : ''
            data.room_status = this.handleRoomStatus(data)
            return data
        },
        handleRoomStatus: function (state){
            if (state.date_in){
                return 2
            } else if ( state.deposits && state.deposits.length ) {
                return 1
            } else return 0
        },
		exportCSV: function(){
			const rows = this.items.map(item => {
				return {
					"Tòa nhà": item.building,
					"Số phòng": item.room_id,
					"Mã quản lý": item.room_state_id,
					"Ngày cọc": formatTimeServer(item.date_deposit),
					"Ngày hẹn nhận phòng": formatTimeServer(item.date_schedule_in),
					"Tình trạng phòng": this.room_status[item.room_status],
					"Tình trạng cọc": item.deposit_status ? 'Đã cọc đủ' : 'Chưa cọc đủ',
					"Giá phòng": item.room_price,
					"Giá cọc": item.deposit_price,
					"Tổng cộng": item.total_price,
					"Tiền đã đóng": item.collected_amount,
					"Tiền còn thiếu": item.debt,
				}
            })
            const date = new Date().toISOString().substr(0,10);
			this.export_csv.rows = rows;
			this.export_csv.title = "ds-no-tien-coc-" + date;
			this.export_csv.trigger = !this.export_csv.trigger;
		}
    }
};
</script>